import {useState} from "react";

export const useDisclosure = (initialState = false) => {
  const [isOpen, setOpen] = useState(initialState);

  const onOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const toggleOpen = () => {
    setOpen((isOpen) => !isOpen);
  };

  return {isOpen, onOpen, onClose, toggleOpen};
};
